import { memo } from "react"

import { faIcon } from "@utils/faIcon"

import { Button } from "@atoms/index"

import { useComponentNavigation } from "@organisms/ComponentNavigation/ComponentNavigation.context"

import useAuth from "@pages/Auth/Auth.store"

import styles from "./AuthAlternativeLoginMethods.module.scss"
import AuthSocialButtons from "./AuthSocialButtons/AuthSocialButtons"

function AuthAlternativeLoginMethods() {
    const { preferredAuthMethod } = useAuth()
    const { navigate, currentComponentId } = useComponentNavigation()

    const isUsingEmail = preferredAuthMethod === "email_and_code" || preferredAuthMethod === "email_and_password"
    const isOnOTPSlide = currentComponentId?.endsWith("_otp")

    const toggleAuthMethod = () => {
        if (preferredAuthMethod === "email_and_code") {
            navigate("phone_and_code")
        } else if (preferredAuthMethod === "phone_and_code") {
            navigate("email_and_code")
        } else if (preferredAuthMethod === "email_and_password") {
            navigate("phone_and_password")
        } else {
            navigate("email_and_password")
        }
    }

    if (isOnOTPSlide) {
        return null
    } else {
        return (
            <div className={styles.base}>
                <>
                    <Button
                        type="button"
                        size="lg"
                        onClick={toggleAuthMethod}
                        variant="subtle"
                        isFullWidth={true}
                        data-prevent-input-validation={true}
                        leftIcon={
                            isUsingEmail
                                ? faIcon({ name: "phone", style: "regular" })
                                : faIcon({ name: "at", style: "regular" })
                        }
                    >
                        Continue with {isUsingEmail ? "phone" : "email"}
                    </Button>
                    <AuthSocialButtons />
                </>
            </div>
        )
    }
}

export default memo(AuthAlternativeLoginMethods)
